import { useEffect, useState } from "react";
import { FaBridgeCircleCheck } from "react-icons/fa6";
import { IoPerson } from "react-icons/io5";
import { MdOutlineArchitecture } from "react-icons/md";
import { RiMapPinRangeFill } from "react-icons/ri";
import { SiTestrail } from "react-icons/si";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { notify, Toast } from "../../common/Toast/index.js";
import FormFields from "../../common/FormFields/index.js";
import { FaStarOfLife } from "react-icons/fa";
import { getEntityFields, getSaveUrl } from "../../utlis/entityConfig.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const Details = ({ isModelOpen }) => {
  const permission = getUserMenuPermission(7);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOwnerData, setIsOwnerData] = useState([]);
  const [isArchitectData, setIsArchitectData] = useState([]);
  const [isFabricatorData, setIsFabricatorData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEntityType, setCurrentEntityType] = useState(null);
  const [isSalePersonData, setIsSalePersonData] = useState([]);
  const { siteData, isReadOnly } = location.state || {};
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Site_Id: "",
    Site_Name: "",
    Site_Type: "",
    address: "",
    location_Link: "",
    sale_Person_Id: "",
    Remark: "",
    mobile_No: "",
    Owner_ID: "",
    owner_Name: "",
    ownerContact: "",
    ownerEmail: "",
    ownerAddress: "",
    ownerFirm: "",
    Architect_ID: "",
    architect_Name: "",
    architectContact: "",
    architectEmail: "",
    architectAddress: "",
    architectFirm: "",
    Fabricator_ID: "",
    febricator_Name: "",
    fabricatorContact: "",
    fabricatorEmail: "",
    fabricatorAddress: "",
    fabricatorFirm: "",
  });
  const userId = sessionStorage.getItem("userId");

  useEffect(() => {
    fetchData();
    fetchSalePerson();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Site_Name.trim()) {
      newErrors.Site_Name = "Site Name is required";
    }
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }
    if (!formData.sale_Person_Id) {
      newErrors.sale_Person_Id = "Sale Person is required";
    }
    if (!formData.mobile_No) {
      newErrors.mobile_No = "Contact No is required";
    } else if (!/^\d{10}$/.test(formData.mobile_No)) {
      newErrors.mobile_No = "Invalid contact number (must be 10 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchData = async () => {
    try {
      const [ownerRes, architectRes, fabricatorRes] = await Promise.all([
        axiosInstance.get("Owner/GetAll"),
        axiosInstance.get("Architect/GetAll"),
        axiosInstance.get("Fabricator/GetAll"),
      ]);
      setIsOwnerData(ownerRes.data);
      setIsArchitectData(architectRes.data);
      setIsFabricatorData(fabricatorRes.data);
    } catch (error) {
      notify("Error fetching data:", error);
      setIsOwnerData([]);
      setIsArchitectData([]);
      setIsFabricatorData([]);
    }
  };

  const handleInputChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({
        ...prev,
        id: e ? e.value : "",
      }));
    }
  };

  useEffect(() => {
    const fetchEntityDetails = async () => {
      try {
        if (siteData.owner_Id) {
          const res = await axiosInstance.get(
            `Owner/GetById/${siteData.owner_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            ownerContact: data.contact_No,
            ownerEmail: data.email_ID,
            ownerAddress: data.office_Address,
            ownerFirm: data.firm_Name,
          }));
        }
        if (siteData.architect_Id) {
          const res = await axiosInstance.get(
            `Architect/GetById/${siteData.architect_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            architectContact: data.contact_No,
            architectEmail: data.email_ID,
            architectAddress: data.office_Address,
            architectFirm: data.firm_Name,
          }));
        }
        if (siteData.fabricator_Id) {
          const res = await axiosInstance.get(
            `Fabricator/GetById/${siteData.fabricator_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            fabricatorContact: data.contact_No,
            fabricatorEmail: data.email_ID,
            fabricatorAddress: data.office_Address,
            fabricatorFirm: data.firm_Name,
          }));
        }
      } catch (error) {
        console.error("Error fetching details by ID", error);
      }
    };

    if (siteData) {
      setIsEditing(true);
      setFormData({
        Site_Id: siteData.site_Id || "",
        Site_Name: siteData.site_Name || "",
        Site_Type: siteData.site_Type || "",
        address: siteData.address || "",
        location_Link: siteData.location_Link || "",
        sale_Person_Id: siteData.sale_Person_Id || "",
        Remark: siteData.Remark || "",
        mobile_No: siteData.mobile_No || "",
        Owner_ID: siteData.owner_Id || "",
        Architect_ID: siteData.architect_Id || "",
        Fabricator_ID: siteData.fabricator_Id || "",
      });
      fetchEntityDetails();
    } else {
      setIsEditing(false);
      setFormData({
        Site_Name: "",
        Site_Type: "",
        address: "",
        location_Link: "",
        sale_Person_Id: "",
        Remark: "",
        mobile_No: "",
        Owner_ID: "",
        Architect_ID: "",
        Fabricator_ID: "",
      });
    }
  }, [siteData]);

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    if (!isEditing && !permission.isInsert) return;
    if (isEditing && !permission.isUpdate) return;
    const payload = {
      Site_Id: formData.Site_Id,
      Site_Name: formData.Site_Name,
      Site_Type: formData.Site_Type,
      Address: formData.address,
      Location_Link: formData.location_Link,
      sale_Person_Id: formData.sale_Person_Id
        ? Number(formData.sale_Person_Id)
        : null,
      Remark: formData.Remark,
      Mobile_No: formData.mobile_No,
      Owner_ID:
        formData.Owner_ID && !isNaN(Number(formData.Owner_ID))
          ? Number(formData.Owner_ID)
          : null,
      Architect_ID:
        formData.Architect_ID && !isNaN(Number(formData.Architect_ID))
          ? Number(formData.Architect_ID)
          : null,
      Fabricator_ID:
        formData.Fabricator_ID && !isNaN(Number(formData.Fabricator_ID))
          ? Number(formData.Fabricator_ID)
          : null,
      Created_By: userId,
      UpdatedBy: userId,
    };

    try {
      const response = await axiosInstance.post(
        "SiteDetail/InsertUpdate",
        payload
      );

      if (response.data) {
        notify(
          isEditing
            ? "SiteDetail updated successfully!"
            : "SiteDetail added successfully!",
          "success"
        );
        setTimeout(() => navigate("/transaction/sites"), 1000);
      } else {
        notify("Something went wrong. Please try again.");
      }
    } catch (error) {
      notify("Error saving site:", error);
      notify(
        `Failed to save site. Error: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };
  const capitalize = (s) => s && s.charAt(0).toUpperCase() + s.slice(1);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...(currentEntityType && {
        [`${currentEntityType}_Name`]: formData.name,
        contact_No: formData.contactNo,
        email_ID: formData.email,
        firm_Name: formData.firmName,
        office_Address: formData.officeAddress,
      }),
    };

    const url = getSaveUrl(currentEntityType);

    try {
      await axiosInstance.post(url, payload);

      await fetchData();
      const latestList =
        currentEntityType === "owner"
          ? isOwnerData
          : currentEntityType === "architect"
          ? isArchitectData
          : isFabricatorData;

      const addedItem = latestList.find(
        (item) => item[`${currentEntityType}_Name`] === formData.name
      );

      // Create updated fields for formData
      const updatedFields = {
        [`${capitalize(currentEntityType)}_ID`]:
          addedItem?.[`${currentEntityType}_ID`] || "",
      };

      if (currentEntityType === "owner") {
        updatedFields.ownerContact = addedItem?.contact_No || "";
        updatedFields.ownerEmail = addedItem?.email_ID || "";
        updatedFields.ownerAddress = addedItem?.office_Address || "";
        updatedFields.ownerFirm = addedItem?.firm_Name || "";
      } else if (currentEntityType === "architect") {
        updatedFields.architectContact = addedItem?.contact_No || "";
        updatedFields.architectEmail = addedItem?.email_ID || "";
        updatedFields.architectAddress = addedItem?.office_Address || "";
        updatedFields.architectFirm = addedItem?.firm_Name || "";
      } else if (currentEntityType === "fabricator") {
        updatedFields.fabricatorContact = addedItem?.contact_No || "";
        updatedFields.fabricatorEmail = addedItem?.email_ID || "";
        updatedFields.fabricatorAddress = addedItem?.office_Address || "";
        updatedFields.fabricatorFirm = addedItem?.firm_Name || "";
      }
      setFormData((prev) => ({
        ...prev,
        ...updatedFields,
      }));

      setIsModalOpen(false);
    } catch (error) {
      notify("Error saving data:", error);
    }
  };
  const clearModalFormData = () => {
    setFormData((prev) => ({
      ...prev,
      name: "",
      contactNo: "",
      email: "",
      firmName: "",
      officeAddress: "",
    }));
  };

  const fetchSalePerson = async () => {
    try {
      const res = await axiosInstance.get(`User/GetAllUser`);
      setIsSalePersonData(res.data);
    } catch (error) {
      notify("Error fetching Account Groups:", error);
    }
  };
  const options = [
    ...(Array.isArray(isSalePersonData) ? isSalePersonData : []).map(
      (person) => ({
        value: person.sale_Person_Id?.toString() || "",
        label: person.Sale_Person_Name || "Unnamed Site",
      })
    ),
  ];
  const ownerOptions = [
    ...(Array.isArray(isOwnerData) ? isOwnerData : []).map((owner) => ({
      value: owner.owner_ID?.toString() || "",
      label: owner.owner_Name || "Unnamed Owner",
    })),
    { value: "add-new", label: "+ Add New Owner" },
  ];
  const architectOptions = [
    ...(Array.isArray(isArchitectData) ? isArchitectData : []).map(
      (architect) => ({
        value: architect.architect_ID?.toString() || "",
        label: architect.architect_Name || "Unnamed Architect",
      })
    ),
    { value: "add-new", label: "+ Add New Architect" },
  ];
  const fabricatorOptions = [
    ...(Array.isArray(isFabricatorData) ? isFabricatorData : []).map(
      (fabricator) => ({
        value: fabricator.fabricator_ID?.toString() || "",
        label: fabricator.fabricator_Name || "Unnamed Site",
      })
    ),
    { value: "add-new", label: "+ Add New Fabricator" },
  ];
  const siteTypeOptions = [
    { value: "project", label: "Project" },
    { value: "bunglow", label: "Bungalow" },
  ];
  const handleEntityChange = (selectedOption, type, entityList) => {
    if (!selectedOption) {
      setFormData((prev) => ({
        ...prev,
        [`${capitalize(type)}_ID`]: "",
        ...(type === "owner"
          ? {
              ownerContact: "",
              ownerEmail: "",
              ownerAddress: "",
              ownerFirm: "",
            }
          : type === "architect"
          ? {
              architectContact: "",
              architectEmail: "",
              architectAddress: "",
              architectFirm: "",
            }
          : {
              fabricatorContact: "",
              fabricatorEmail: "",
              fabricatorAddress: "",
              fabricatorFirm: "",
            }),
      }));
      return;
    }

    if (selectedOption.value === "add-new") {
      setCurrentEntityType(type);
      clearModalFormData();
      setIsModalOpen(true);
      return;
    }

    const selected = entityList.find(
      (item) => String(item[`${type}_ID`]) === selectedOption.value
    );

    const updatedFields = {
      [`${capitalize(type)}_ID`]: selectedOption.value,
    };

    if (type === "owner") {
      updatedFields.ownerContact = selected?.contact_No || "";
      updatedFields.ownerEmail = selected?.email_ID || "";
      updatedFields.ownerAddress = selected?.office_Address || "";
      updatedFields.ownerFirm = selected?.firm_Name || "";
    } else if (type === "architect") {
      updatedFields.architectContact = selected?.contact_No || "";
      updatedFields.architectEmail = selected?.email_ID || "";
      updatedFields.architectAddress = selected?.office_Address || "";
      updatedFields.architectFirm = selected?.firm_Name || "";
    } else if (type === "fabricator") {
      updatedFields.fabricatorContact = selected?.contact_No || "";
      updatedFields.fabricatorEmail = selected?.email_ID || "";
      updatedFields.fabricatorAddress = selected?.office_Address || "";
      updatedFields.fabricatorFirm = selected?.firm_Name || "";
    }

    setFormData((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  };

  return (
    <>
      <Toast />
      <div
        className={`${
          isModelOpen
            ? " "
            : "rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5"
        } `}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h1 className="text-lg font-bold">Site Details</h1>
          </div>
          <button
            className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-secondary"
            onClick={() => navigate(`/transaction/sites`)}
          >
            Back
          </button>
        </div>

        <form onSubmit={onHandleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border rounded-lg shadow-md">
              <div className="flex items-center justify-between gap-4 mb-6 bg-[#f1f4f9] px-6 py-4 border-b border-gray-200">
                <div className="flex items-center gap-2">
                  <SiTestrail className="text-success w-6 h-6" />
                  <h2 className="text-base font-semibold text-[#405189]">
                    Site Details
                  </h2>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 p-4">
                <div className="relative">
                  <label className="flex items-center text-sm font-medium mb-1">
                    Site Name
                    <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                  </label>
                  <input
                    type="text"
                    name="Site_Name"
                    value={formData.Site_Name}
                    onChange={handleInputChange}
                    placeholder="Enter Site Name"
                    disabled={isReadOnly}
                    className={`w-full border rounded p-2 outline-none focus:ring-1 ${
                      errors.Site_Name
                        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                        : "border-gray-300 focus:ring-primary focus:border-primary"
                    }`}
                  />
                  {/* <input
                    type="text"
                    name="Site_Name"
                    value={formData.Site_Name}
                    onChange={handleInputChange}
                    placeholder="Enter Site Name"
                    className={`w-full border rounded p-2   ${
                      errors.Site_Name
                        ? "border-red-500"
                        : "border-gray-300 focus:ring-primary focus:border-primary"
                    }`}
                    disabled={isReadOnly}
                  /> */}
                  {errors.Site_Name && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.Site_Name}
                    </p>
                  )}
                </div>
                <div>
                  <label className="text-sm font-medium mb-1 block">
                    Site Type
                  </label>
                  <Select
                    name="Site_Type"
                    isSearchable={false}
                    options={siteTypeOptions}
                    value={siteTypeOptions.find(
                      (option) => option.value === formData.Site_Type
                    )}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "Site_Type",
                          value: selectedOption?.value || "",
                        },
                      })
                    }
                    isDisabled={isReadOnly}
                    placeholder="-- Select Site Type --"
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="flex items-center text-sm font-medium mb-1">
                    Address{" "}
                    <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                  </label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className={`w-full border rounded p-2 outline-none focus:ring-1 ${
                      errors.address
                        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                        : "border-gray-300 focus:ring-primary focus:border-primary"
                    }`}
                    placeholder="Enter Site Address"
                    disabled={isReadOnly}
                  />
                  {errors.address && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.address}
                    </p>
                  )}
                </div>
                <div className="md:col-span-2">
                  <label className="text-sm font-medium mb-1 block">
                    Remark
                  </label>
                  <textarea
                    name="Remark"
                    value={formData.Remark}
                    onChange={handleInputChange}
                    placeholder="Enter any Remark"
                    className="border rounded-md w-full p-2 focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                    disabled={isReadOnly}
                  />
                </div>
                <div className="relative">
                  <label className="flex items-center text-sm font-medium mb-1">
                    Sale Person{" "}
                    <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                  </label>
                  <Select
                    options={options}
                    value={
                      options.find(
                        (option) =>
                          Number(option.value) ===
                          Number(formData.sale_Person_Id)
                      ) || null
                    }
                    isClearable
                    isSearchable
                    disabled={isReadOnly}
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        sale_Person_Id: selectedOption
                          ? selectedOption.value
                          : "",
                      }))
                    }
                    className="mt-1"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        borderColor: errors.sale_Person_Id
                          ? "#ef4444"
                          : "#e5e7eb",
                        boxShadow: "none",
                        "&:hover": { borderColor: "gray" },
                      }),
                    }}
                  />
                  {errors.sale_Person_Id && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.sale_Person_Id}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label className="flex items-center text-sm font-medium mb-1">
                    Site Contact No{" "}
                    <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                  </label>
                  <input
                    type="text"
                    name="mobile_No"
                    value={formData.mobile_No}
                    onChange={handleInputChange}
                    placeholder="Enter Contact No"
                    className={`w-full border rounded p-2 focus:ring-1 outline-none  ${
                      errors.mobile_No
                        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                        : "border-gray-300 focus:ring-primary focus:border-primary"
                    }`}
                  />
                  {errors.mobile_No && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.mobile_No}
                    </p>
                  )}
                </div>
                <div className="relative md:col-span-2">
                  <label className="text-sm font-medium mb-1 block">
                    Location
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="location_Link"
                      value={formData.location_Link}
                      onChange={handleInputChange}
                      placeholder="Enter Location"
                      className="border rounded-md w-full p-2 focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      disabled={isReadOnly}
                    />
                    <button
                      className="absolute right-2 top-1/2 transform -translate-y-1/2 p-2"
                      type="button"
                    >
                      <RiMapPinRangeFill className="w-5 h-5 text-primary" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="border rounded-lg shadow-sm">
              <div className="flex items-center justify-between gap-4 mb-6 bg-[#f1f4f9] px-6 py-4 border-b border-gray-200">
                <div className="flex items-center gap-2">
                  <IoPerson className="text-success w-6 h-6" />
                  <h2 className="text-base font-semibold text-[#405189]">
                    Owner Details
                  </h2>
                </div>
              </div>
              <div className="p-4">
                <Select
                  options={ownerOptions}
                  value={
                    ownerOptions.find(
                      (option) =>
                        String(option.value) === String(formData.Owner_ID)
                    ) || null
                  }
                  isClearable
                  isSearchable
                  onChange={(selected) =>
                    handleEntityChange(selected, "owner", isOwnerData)
                  }
                  disabled={isReadOnly}
                  className="mt-1"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "gray",
                      boxShadow: "none",
                      "&:hover": { borderColor: "gray" },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    option: (provided, { data }) => ({
                      ...provided,
                      backgroundColor:
                        data.value === "add-new"
                          ? "#F3F4F6"
                          : provided.backgroundColor,
                      fontWeight: data.value === "add-new" ? "bold" : "normal",
                      cursor: "pointer",
                      position:
                        data.value === "add-new" ? "sticky" : "relative",
                      bottom: data.value === "add-new" ? "0" : "auto",
                    }),
                  }}
                />
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <input
                    type="tel"
                    name="ownerContact"
                    placeholder="Contact No."
                    value={formData.ownerContact}
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                  <input
                    type="email"
                    name="ownerEmail"
                    placeholder="Email"
                    value={formData.ownerEmail}
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                </div>
                <textarea
                  name="ownerAddress"
                  placeholder="Address"
                  value={formData.ownerAddress}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                  rows="4"
                ></textarea>
                <input
                  type="text"
                  name="ownerFirm"
                  placeholder="Firm Name"
                  value={formData.ownerFirm}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                />
              </div>
            </div>
            <div className="border rounded-lg p-4 shadow-sm">
              <div className="flex items-center justify-between gap-4 mb-6 bg-[#f1f4f9] px-6 py-4 border-b border-gray-200">
                <div className="flex items-center gap-2">
                  <MdOutlineArchitecture className="text-success w-6 h-6" />
                  <h2 className="text-base font-semibold text-[#405189]">
                    Architect Details
                  </h2>
                </div>
              </div>
              <div className="p-4">
                <Select
                  options={architectOptions}
                  value={
                    architectOptions.find(
                      (option) =>
                        String(option.value) === String(formData.Architect_ID)
                    ) || null
                  }
                  isClearable
                  isSearchable
                  onChange={(selected) =>
                    handleEntityChange(selected, "architect", isArchitectData)
                  }
                  disabled={isReadOnly}
                  className="mt-1"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "gray",
                      boxShadow: "none",
                      "&:hover": { borderColor: "gray" },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    option: (provided, { data }) => ({
                      ...provided,
                      backgroundColor:
                        data.value === "add-new"
                          ? "#F3F4F6"
                          : provided.backgroundColor,
                      fontWeight: data.value === "add-new" ? "bold" : "normal",
                      cursor: "pointer",
                      position:
                        data.value === "add-new" ? "sticky" : "relative",
                      bottom: data.value === "add-new" ? "0" : "auto",
                    }),
                  }}
                />
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <input
                    type="tel"
                    name="architectContact"
                    value={formData.architectContact}
                    placeholder="Contact No."
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                  <input
                    type="email"
                    name="architectEmail"
                    placeholder="Email"
                    value={formData.architectEmail}
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                </div>
                <textarea
                  name="architectAddress"
                  placeholder="Address"
                  rows="4"
                  value={formData.architectAddress}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                ></textarea>
                <input
                  type="text"
                  name="architectFirm"
                  placeholder="Firm Name"
                  value={formData.architectFirm}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                />
              </div>
            </div>
            <div className="border rounded-lg p-4 shadow-sm">
              <div className="flex items-center justify-between gap-4 mb-6 bg-[#f1f4f9] px-6 py-4 border-b border-gray-200">
                <div className="flex items-center gap-2">
                  <FaBridgeCircleCheck className="text-success w-6 h-6" />
                  <h2 className="text-base font-semibold text-[#405189]">
                    Fabricator Details
                  </h2>
                </div>
              </div>
              <div className="p-4">
                <Select
                  options={fabricatorOptions}
                  value={
                    fabricatorOptions.find(
                      (option) =>
                        String(option.value) === String(formData.Fabricator_ID)
                    ) || null
                  }
                  isClearable
                  isSearchable
                  onChange={(selected) =>
                    handleEntityChange(selected, "fabricator", isFabricatorData)
                  }
                  disabled={isReadOnly}
                  className="mt-1"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "gray",
                      boxShadow: "none",
                      "&:hover": { borderColor: "gray" },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }),
                    option: (provided, { data }) => ({
                      ...provided,
                      backgroundColor:
                        data.value === "add-new"
                          ? "#F3F4F6"
                          : provided.backgroundColor,
                      fontWeight: data.value === "add-new" ? "bold" : "normal",
                      cursor: "pointer",
                      position:
                        data.value === "add-new" ? "sticky" : "relative",
                      bottom: data.value === "add-new" ? "0" : "auto",
                    }),
                  }}
                />
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <input
                    type="tel"
                    name="fabricatorContact"
                    placeholder="Contact No."
                    value={formData.fabricatorContact}
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                  <input
                    type="email"
                    name="fabricatorEmail"
                    value={formData.fabricatorEmail}
                    placeholder="Email"
                    className="w-full border rounded p-2 bg-gray-2"
                    disabled
                  />
                </div>
                <textarea
                  name="fabricatorAddress"
                  placeholder="Address"
                  rows="4"
                  value={formData.fabricatorAddress}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                ></textarea>
                <input
                  type="text"
                  name="fabricatorFirm"
                  placeholder="Firm Name"
                  value={formData.fabricatorFirm}
                  className="w-full border rounded p-2 mt-4 bg-gray-2"
                  disabled
                />
              </div>
            </div>
          </div>
          {!isReadOnly && (
            <button
              type="submit"
              className="bg-primary px-4 py-2 rounded mt-4 text-white"
            >
              {isEditing ? "Update" : "Save"}
            </button>
          )}

          <button
            type="button"
            className="bg-gray px-4 py-2 rounded mt-4 text-black ml-4"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </form>
      </div>
      <Model
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          clearModalFormData();
        }}
        name={`Add New ${currentEntityType}`}
      >
        <FormFields
          fields={getEntityFields(currentEntityType)}
          formData={formData}
          handleInputChange={handleInputChange}
          onSubmit={handleSubmit}
          onClear={() => setIsModalOpen(false)}
        />
      </Model>
    </>
  );
};

export default Details;
